goog.provide("shadow.js.shim.module$date_fns$locale$he$default");
shadow.js.shim.module$date_fns$locale$he$default = esm_import$date_fns$locale$he.default;
